// extracted by mini-css-extract-plugin
export default {"modal":"modal_modal__7PuEk","form":"modal_form__1Ua5t","modalContent":"modal_modalContent__-vFM2","toolboxContainer":"modal_toolboxContainer__jtSFI","toolbox":"modal_toolbox__7qxT1"};